module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_sanduba.ec307adf.png";